import Rails from "@rails/ujs";

export default ({ externalPositionId, success, error }) => {
  Rails.ajax({
    type: "GET",
    dataType: "json",
    url: `/api/external_positions/${externalPositionId}/fetch_flights`,
    success,
    error,
  });
};
